import type { TFunction } from 'i18next';
import { z } from 'zod';

export const getMediaPlanSchema = (t: TFunction<'campaign-planner'>) =>
  z.object({
    planName: z.string().min(1, {
      message: t('digitalCampaigns.mediaPlan.validation.planNameRequired'),
    }),
    platforms: z.array(
      z.object({
        mediaPlatform: z.string().min(1),
        plans: z.array(
          z.object({
            market: z.string().min(1, {
              message: t(
                'digitalCampaigns.mediaPlan.validation.marketRequired',
              ),
            }),
            budget: z.number().min(0, {
              message: t(
                'digitalCampaigns.mediaPlan.validation.budgetRequired',
              ),
            }),
            audienceSize: z.number().min(0, {
              message: t(
                'digitalCampaigns.mediaPlan.validation.audienceSizeRequired',
              ),
            }),
            frequency: z.object({
              amount: z.number().min(0, {
                message: t(
                  'digitalCampaigns.mediaPlan.validation.frequencyAmountRequired',
                ),
              }),
              period: z.string().min(1),
            }),
            goal: z.string().min(1, {
              message: t('digitalCampaigns.mediaPlan.validation.goalRequired'),
            }),
          }),
        ),
      }),
    ),
  });
